import State from '@/onsite/models/state.model';
import OnsiteSearchAppData from '@/onsite/utility/onsite-search-app-data';
import { getLastQueryStrings } from '@/shared/utility/last-query-strings';

if (!OnsiteSearchAppData) {
  throw new TypeError("Onsite search app data is not available");
}

const { translations } = OnsiteSearchAppData;

if (!translations) {
  throw new TypeError("Translation object is not available");
}

// Set initial state
const state: State = {
  translations,
  queryString: "",
  initialTab: "",
  selectedTab: "",
  totalResults: 0,
  productGroup: {
    totalResults: 0,
    results: []
  },
  groups: [],
  allTabSelected: true,
  lastQueryStrings: getLastQueryStrings(),
};

export default state;
